// package: workspace
// file: workspace.proto

var workspace_pb = require("./workspace_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Workspaces = (function () {
  function Workspaces() {}
  Workspaces.serviceName = "workspace.Workspaces";
  return Workspaces;
}());

Workspaces.Create = {
  methodName: "Create",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceCreateRequest,
  responseType: workspace_pb.WorkspaceCreateReply
};

Workspaces.Update = {
  methodName: "Update",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceUpdateRequest,
  responseType: workspace_pb.WorkspaceUpdateReply
};

Workspaces.Delete = {
  methodName: "Delete",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceDeleteRequest,
  responseType: workspace_pb.WorkspaceDeleteReply
};

Workspaces.Get = {
  methodName: "Get",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceGetRequest,
  responseType: workspace_pb.WorkspaceGetReply
};

Workspaces.List = {
  methodName: "List",
  service: Workspaces,
  requestStream: false,
  responseStream: true,
  requestType: workspace_pb.WorkspaceListRequest,
  responseType: workspace_pb.WorkspaceListReply
};

Workspaces.AddUser = {
  methodName: "AddUser",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceAddUserRequest,
  responseType: workspace_pb.WorkspaceAddUserReply
};

Workspaces.RemoveUser = {
  methodName: "RemoveUser",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceRemoveUserRequest,
  responseType: workspace_pb.WorkspaceRemoveUserReply
};

Workspaces.ListUser = {
  methodName: "ListUser",
  service: Workspaces,
  requestStream: false,
  responseStream: true,
  requestType: workspace_pb.WorkspaceListUserRequest,
  responseType: workspace_pb.WorkspaceListUserReply
};

Workspaces.CountUser = {
  methodName: "CountUser",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceCountUserRequest,
  responseType: workspace_pb.WorkspaceCountUserReply
};

Workspaces.UpdateUserRole = {
  methodName: "UpdateUserRole",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceUpdateUserRoleRequest,
  responseType: workspace_pb.WorkspaceUpdateUserRoleReply
};

Workspaces.TransferOwnerShip = {
  methodName: "TransferOwnerShip",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceTransferOwnerShipRequest,
  responseType: workspace_pb.WorkspaceTransferOwnerShipReply
};

Workspaces.ListPendingInvitation = {
  methodName: "ListPendingInvitation",
  service: Workspaces,
  requestStream: false,
  responseStream: true,
  requestType: workspace_pb.WorkspaceListPendingInvitationRequest,
  responseType: workspace_pb.WorkspaceListPendingInvitationReply
};

Workspaces.CountPendingInvitation = {
  methodName: "CountPendingInvitation",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceCountPendingInvitationRequest,
  responseType: workspace_pb.WorkspaceCountPendingInvitationReply
};

Workspaces.ResendInvitation = {
  methodName: "ResendInvitation",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceResendInvitationRequest,
  responseType: workspace_pb.WorkspaceResendInvitationReply
};

Workspaces.DeleteInvitation = {
  methodName: "DeleteInvitation",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceDeleteInvitationRequest,
  responseType: workspace_pb.WorkspaceDeleteInvitationReply
};

Workspaces.GetCurrentUserRole = {
  methodName: "GetCurrentUserRole",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceGetCurrentUserRoleRequest,
  responseType: workspace_pb.WorkspaceGetCurrentUserRoleReply
};

Workspaces.GetConfig = {
  methodName: "GetConfig",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceGetConfigRequest,
  responseType: workspace_pb.WorkspaceGetConfigReply
};

Workspaces.UpdateConfig = {
  methodName: "UpdateConfig",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceUpdateConfigRequest,
  responseType: workspace_pb.WorkspaceUpdateConfigReply
};

Workspaces.GetApiKey = {
  methodName: "GetApiKey",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceGetApiKeyRequest,
  responseType: workspace_pb.WorkspaceGetApiKeyReply
};

Workspaces.ResetApiKey = {
  methodName: "ResetApiKey",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceResetApiKeyRequest,
  responseType: workspace_pb.WorkspaceResetApiKeyReply
};

Workspaces.AdminCreate = {
  methodName: "AdminCreate",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceAdminCreateRequest,
  responseType: workspace_pb.WorkspaceAdminCreateReply
};

Workspaces.AdminDelete = {
  methodName: "AdminDelete",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceAdminDeleteRequest,
  responseType: workspace_pb.WorkspaceAdminDeleteReply
};

Workspaces.AdminRemoveUser = {
  methodName: "AdminRemoveUser",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceAdminRemoveUserRequest,
  responseType: workspace_pb.WorkspaceAdminRemoveUserReply
};

Workspaces.AdminSetUserRole = {
  methodName: "AdminSetUserRole",
  service: Workspaces,
  requestStream: false,
  responseStream: false,
  requestType: workspace_pb.WorkspaceAdminSetUserRoleRequest,
  responseType: workspace_pb.WorkspaceAdminSetUserRoleReply
};

exports.Workspaces = Workspaces;

function WorkspacesClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

WorkspacesClient.prototype.create = function create(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.Create, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.update = function update(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.Update, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.delete = function pb_delete(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.Delete, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.get = function get(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.Get, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.list = function list(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Workspaces.List, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.addUser = function addUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.AddUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.removeUser = function removeUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.RemoveUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.listUser = function listUser(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Workspaces.ListUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.countUser = function countUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.CountUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.updateUserRole = function updateUserRole(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.UpdateUserRole, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.transferOwnerShip = function transferOwnerShip(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.TransferOwnerShip, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.listPendingInvitation = function listPendingInvitation(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Workspaces.ListPendingInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.countPendingInvitation = function countPendingInvitation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.CountPendingInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.resendInvitation = function resendInvitation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.ResendInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.deleteInvitation = function deleteInvitation(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.DeleteInvitation, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.getCurrentUserRole = function getCurrentUserRole(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.GetCurrentUserRole, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.getConfig = function getConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.GetConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.updateConfig = function updateConfig(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.UpdateConfig, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.getApiKey = function getApiKey(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.GetApiKey, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.resetApiKey = function resetApiKey(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.ResetApiKey, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.adminCreate = function adminCreate(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.AdminCreate, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.adminDelete = function adminDelete(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.AdminDelete, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.adminRemoveUser = function adminRemoveUser(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.AdminRemoveUser, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

WorkspacesClient.prototype.adminSetUserRole = function adminSetUserRole(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Workspaces.AdminSetUserRole, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.WorkspacesClient = WorkspacesClient;

